import { CONSTANT } from '../utils/constant';
import FR from '../../FR.json';
import EN from '../../EN.json';

const getStatusOptions = (userRole, status, isChannelTQPartenaire) => {
  const locale = localStorage.getItem('locale');
  const localeTranslations = locale === 'FR' ? FR : EN;
  const {
    ORDERS: {
      newStatus,
      inProgress,
      actionRequired,
      responded,
      completed,
      canceled,
      waitingOnCustomerResponse,
      waitingOnCredit,
      waitingOnInternet,
      waitingOnNTAOrDSR
    }
  } = localeTranslations;
  let result = [
    { text: newStatus, value: 'New' },
    { text: inProgress, value: 'In Progress' },
    { text: actionRequired, value: 'Action Required' },
    { text: completed, value: 'Completed' },
    { text: canceled, value: 'Canceled' },
    { text: waitingOnCustomerResponse, value: 'Waiting on Customer Response' },
    { text: waitingOnCredit, value: 'Waiting on Credit' },
    { text: waitingOnInternet, value: 'Waiting on Internet' },
    { text: waitingOnNTAOrDSR, value: 'Waiting on NTA or DSR' }
  ];

  if (userRole === CONSTANT.KEYS.ROLES.ADMIN) {
    result.push({ text: responded, value: 'Responded' });
  }

  if (isChannelTQPartenaire) {
    result = [];
    if (!['Responded', 'Canceled'].includes(status)) {
      result.push({ text: status, value: status });
    }
    result.push({ text: responded, value: 'Responded' });
    result.push({ text: canceled, value: 'Canceled' });
  }

  return result;
};

export default getStatusOptions;
